import React, { useState, useEffect } from "react";

const TermsConditions = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [activeSection, setActiveSection] = useState(null);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  const navigationItems = [
    { id: "payments", title: "Payments Conditions", icon: "💳" },
    { id: "admission", title: "Admission Procedure", icon: "📝" },
    { id: "transfer", title: "Transfer Procedure", icon: "🔄" },
    { id: "readmission", title: "Condition for Readmission", icon: "↩️" },
    { id: "appeals", title: "Appeals", icon: "⚖️" },
  ];

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      setActiveSection(sectionId);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white border-b border-gray-200">
        <div className="container mx-auto max-w-7xl px-4 py-6">
          <div
            className={`transition-all duration-1000 ease-out ${
              isVisible
                ? "opacity-100 translate-y-0"
                : "opacity-0 -translate-y-5"
            }`}
          >
            {/* Breadcrumb */}
            {/*<nav className="flex mb-4 text-sm">
              <span className="text-custom-pink hover:text-custom-pink/80 cursor-pointer transition-colors">
                🏠
              </span>
              <span className="mx-2 text-gray-400">></span>
              <span className="text-gray-600">About</span>
              <span className="mx-2 text-gray-400">></span>
              <span className="text-custom-pink font-medium">
                Terms and Conditions
              </span>
            </nav>
            */}

            <h1 className="text-4xl md:text-5xl font-bold text-custom-pink mb-4">
              Terms and Conditions
            </h1>
            <div className="w-16 h-1 bg-gold rounded-full"></div>
          </div>
        </div>
      </div>

      <div className="container mx-auto max-w-7xl px-4 py-8">
        <div className="flex flex-col lg:flex-row gap-8">
          {/* Sidebar Navigation */}
          <div className="lg:w-1/4">
            <div
              className={`bg-white rounded-lg shadow-md p-6 sticky top-6 transition-all duration-1000 delay-300 ${
                isVisible
                  ? "opacity-100 translate-x-0"
                  : "opacity-0 -translate-x-5"
              }`}
            >
              <h3 className="text-lg font-bold text-custom-pink mb-4 border-b border-gray-200 pb-2">
                About JRIIT
              </h3>
              <nav className="space-y-2">
                {navigationItems.map((item, index) => (
                  <button
                    key={item.id}
                    onClick={() => scrollToSection(item.id)}
                    className={`w-full text-left px-3 py-2 rounded-md transition-all duration-300 hover:bg-custom-pink/10 hover:text-custom-pink flex items-center space-x-2 ${
                      activeSection === item.id
                        ? "bg-custom-pink/10 text-custom-pink font-medium"
                        : "text-gray-700"
                    }`}
                  >
                    <span className="text-sm">{item.icon}</span>
                    <span className="text-sm">{item.title}</span>
                  </button>
                ))}
              </nav>
            </div>
          </div>

          {/* Main Content */}
          <div className="lg:w-3/4">
            <div
              className={`bg-white rounded-lg shadow-md transition-all duration-1000 delay-500 ${
                isVisible
                  ? "opacity-100 translate-x-0"
                  : "opacity-0 translate-x-5"
              }`}
            >
              {/* Payments Conditions */}
              <section
                id="payments"
                className="p-8 border-b border-gray-100 last:border-b-0"
              >
                <h2 className="text-2xl font-bold text-custom-pink mb-6 flex items-center space-x-3">
                  <span className="text-2xl">💳</span>
                  <span>Payments Conditions</span>
                </h2>

                <div className="prose prose-lg max-w-none text-gray-700 leading-relaxed space-y-4">
                  <p>
                    Parents and Students must ensure that the fee is paid on
                    time. Failure to disburse the fee before the deadline will
                    result in penalty of 2% per month of the remaining amount
                    until paid. Parents are welcomed to apply for the
                    instalments plan in writing prior to the due date. Parents
                    must remain with the invoice and payment receipt at all time
                    during all three years. In case of any audit or
                    misunderstanding on payment, parent will be required to
                    submit the originals as proof of payment to vouch that
                    payment was done as required otherwise full payment will be
                    required.
                  </p>

                  <p>
                    All fees are to be banked and submit deposit slip to the
                    cashier:
                  </p>

                  <div className="bg-gray-50 p-4 rounded-lg border-l-4 border-gold">
                    <p className="font-semibold text-custom-pink mb-2">
                      ACCOUNT DETAILS:
                    </p>
                    <p>
                      <strong>JR EDUCATIONAL SERVICES LTD</strong>
                    </p>
                    <p>NO: 01J1035181700 - CRDB BANK ARUSHA BRANCH</p>
                    <p>
                      NO: 0000535571 - DIAMOND TRUST BANK (DTB) UHURU
                      BRANCH-ARUSHA
                    </p>
                  </div>

                  <div className="bg-gold/10 p-4 rounded-lg border-l-4 border-gold">
                    <p>
                      <strong>MOBILE PAYMENT:</strong> M-PESA LIPA NUMBER:
                      5591309
                    </p>
                  </div>

                  <p>
                    Receipts will be issued only after the cheque has been
                    cleared. For more information please contact us:
                    <span className="font-semibold text-custom-pink">
                      {" "}
                      0754 360 590 / 0753 888 221 / 0679 414 415
                    </span>
                  </p>
                </div>
              </section>

              {/* Admission Procedure */}
              <section
                id="admission"
                className="p-8 border-b border-gray-100 last:border-b-0"
              >
                <h2 className="text-2xl font-bold text-custom-pink mb-6 flex items-center space-x-3">
                  <span className="text-2xl">📝</span>
                  <span>Admission Procedure</span>
                </h2>

                <div className="prose prose-lg max-w-none text-gray-700 leading-relaxed space-y-4">
                  <p>
                    Selected candidates are required to register after they have
                    paid at least first installment of the tuition fee. The time
                    frame for fee payment and registration will be one month (30
                    days) from the date the College opens; this also applies to
                    students with repeat module or carry forward. Students who
                    will have not completed registration and fee payment process
                    within the specified time frame will automatically lose
                    their students' status and not be able to undertake any
                    course during the particular Semester.
                  </p>

                  <ul className="list-disc list-inside space-y-2 bg-gray-50 p-4 rounded-lg">
                    <li>
                      No student shall be allowed to change an academic
                      programme later than the second week from the commencement
                      of the programme.
                    </li>
                    <li>
                      No change of names by the student shall be allowed during
                      the course of study.
                    </li>
                    <li>
                      Students shall be allowed to use names appearing on the
                      certificates which qualified them for admission.
                    </li>
                    <li>
                      Certificates obtained outside Tanzania should get
                      translation from the National Examinations Council of
                      Tanzania (NECTA).
                    </li>
                  </ul>
                </div>
              </section>

              {/* Transfer Procedure */}
              <section
                id="transfer"
                className="p-8 border-b border-gray-100 last:border-b-0"
              >
                <h2 className="text-2xl font-bold text-custom-pink mb-6 flex items-center space-x-3">
                  <span className="text-2xl">🔄</span>
                  <span>Transfer Procedure</span>
                </h2>

                <div className="prose prose-lg max-w-none text-gray-700 leading-relaxed space-y-4">
                  <p>
                    Registered student from any recognized academic institution
                    may request a transfer to the JR Institute of Information
                    Technology and study one of its programmes of study provided
                    that:
                  </p>

                  <ol className="list-decimal list-inside space-y-2 bg-gray-50 p-4 rounded-lg">
                    <li>
                      He has fulfilled all the transfer procedures provided by
                      relevant authorities.
                    </li>
                    <li>
                      The programme content of study between the two
                      institutions are alike and compatible.
                    </li>
                    <li>
                      Grading and assessment criteria of the programmes are
                      compatible and accepted by the College.
                    </li>
                    <li>
                      Prescribed fee and other financial dues are duly paid to
                      the College.
                    </li>
                    <li>
                      He has no any examination irregularity or disciplinary
                      case.
                    </li>
                  </ol>
                </div>
              </section>

              {/* Readmission */}
              <section
                id="readmission"
                className="p-8 border-b border-gray-100 last:border-b-0"
              >
                <h2 className="text-2xl font-bold text-custom-pink mb-6 flex items-center space-x-3">
                  <span className="text-2xl">↩️</span>
                  <span>Condition for Readmission</span>
                </h2>

                <div className="prose prose-lg max-w-none text-gray-700 leading-relaxed space-y-4">
                  <p>
                    A candidate shall not be allowed to join the same program in
                    which he/she has been discontinued on academic grounds until
                    after one year and the year to be re-admitted, shall be
                    determined by the Board.
                  </p>

                  <div className="bg-red-50 border-l-4 border-red-400 p-4 rounded-lg">
                    <p className="text-red-800 font-medium">
                      However this privilege shall not apply to expelled
                      students on non-academic matters.
                    </p>
                  </div>
                </div>
              </section>

              {/* Appeals */}
              <section id="appeals" className="p-8">
                <h2 className="text-2xl font-bold text-custom-pink mb-6 flex items-center space-x-3">
                  <span className="text-2xl">⚖️</span>
                  <span>Appeals</span>
                </h2>

                <div className="prose prose-lg max-w-none text-gray-700 leading-relaxed space-y-4">
                  <p>
                    As soon as the Academic Committee releases the Examination
                    results, any candidate who has valid ground for appeal
                    shall, within twenty one (21) days (counted from the day of
                    release of provisional results or from the day of the start
                    of a new semester if results are declared during vacation)
                    lodge his/her appeal with the principal.
                  </p>

                  <p>
                    Appeals shall be on valid grounds and shall be in written
                    form and shall be accompanied by relevant and documented
                    substantive evidence.
                  </p>

                  <p>
                    Upon receiving such an appeal the principal may call for
                    investigation and explanation from the Vice Principal
                    Academics to obtain such advice and assistance as it may
                    deem appropriate and make a recommendation, which shall be
                    tabled at the next Academic Committee of the institute.
                  </p>

                  <p>
                    The Principal may, if in his opinion there is a prima facie
                    case, appoint an appeals sub-Committee to hear the appeal
                    and make a recommendation that shall be tabled at the next
                    Academic Committee of the institute.
                  </p>

                  <div className="bg-custom-pink/10 border-l-4 border-custom-pink p-4 rounded-lg">
                    <p className="text-custom-pink font-medium">
                      The decision of the Academic Committee shall constitute
                      therefore the final examination results. The decision will
                      be communicated to the concerned individual candidate
                      through the principal.
                    </p>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;
